import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSkillInvoked.meta';

export type UseTrackSkillInvokedParams = {
  skill_id: string;
  slash_command: string;
  canvas_id: string;
  is_invoked_from_onboarding: boolean;
};

export const useTrackSkillInvoked = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillInvoked = useCallback(
    (params: UseTrackSkillInvokedParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillInvoked };
};
